/**
 * TanStack Query v5 client for @garden/web.
 *
 * Defaults per story Implementation logic step 10:
 *   - staleTime: 30s
 *   - refetchOnWindowFocus: false
 *   - retry: 2
 *
 * The single QueryClient instance is created at module load and reused
 * across all providers. Tests that need isolated state should create
 * their own QueryClient and wrap the component under test.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});
